import { computed } from '@vue/composition-api';
import { useStore } from '@vueblocks/vue-use-vuex';

export default function useCommonCodes(codeGroupName) {
  const store = useStore();
  store.dispatch('fetchCommonCodes', codeGroupName);
  return computed(() => store.getters.commonCodes[codeGroupName] || []);
}
